import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
var cls = 'download-bar';

var DownloadBar = function DownloadBar(_ref) {
  var amount = _ref.amount,
      onCallApp = _ref.onCallApp,
      className = _ref.className,
      style = _ref.style,
      visible = _ref.visible;
  var wrapperRef = useRef(null);

  var _useConfig = useConfig(),
      createNamespace = _useConfig.createNamespace,
      prefixCls = _useConfig.prefixCls,
      setDownloadBarHeight = _useConfig.setDownloadBarHeight;

  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), className);

  var _useState = useState(true),
      isShow = _useState[0],
      setStatus = _useState[1];

  var onClose = function onClose() {
    setStatus(false);
  };

  useEffect(function () {
    var el = wrapperRef.current;

    var handle = function handle() {
      if (isShow && visible && el) {
        setDownloadBarHeight(el.offsetHeight);
      } else {
        setDownloadBarHeight(0);
      }
    };

    handle();
    window.addEventListener('resize', handle);
    return function () {
      window.removeEventListener('resize', handle);
    };
  }, [isShow, visible, setDownloadBarHeight]);
  return visible && isShow ? _jsxs("div", Object.assign({
    className: classes,
    style: style,
    ref: wrapperRef
  }, {
    children: [_jsx("div", {
      onClick: onClose,
      className: "close-btn"
    }), _jsx("img", {
      className: "logo",
      src: "https://baleen-cdn-g.bybieyang.com/static/images/logo.png"
    }), _jsxs("div", Object.assign({
      className: "content"
    }, {
      children: [_jsx("div", Object.assign({
        className: "title"
      }, {
        children: "\u522B\u6837\u6D77\u5916\u8D2DAPP"
      })), _jsxs("div", Object.assign({
        className: "sub-title"
      }, {
        children: ["\u65B0\u7528\u6237\u53EF\u9650\u65F6\u9886\u53D6", _jsxs("span", Object.assign({
          className: "amount"
        }, {
          children: [amount, "\u5927\u793C\u5305"]
        }))]
      }))]
    })), _jsx("div", Object.assign({
      onClick: function onClick() {
        return onCallApp === null || onCallApp === void 0 ? void 0 : onCallApp();
      },
      className: "call-app"
    }, {
      children: "\u6253\u5F00APP"
    }))]
  })) : null;
};

DownloadBar.displayName = 'DownloadBar';
export default DownloadBar;